const locale = {
	OVERVIEW: 'Overview',
	CALENDAR: "Calendar",
	REQUESTS: "Requests",
	TASKS: "Tasks",
	REPORTS: 'Reports',
	TRIPS: 'Trips',
	VEHICLES: 'Vehicles',
	EMPLOYEES: "Employees",
	ADMINISTRATION: "Administration",
	CHANGELOG: "Changelog",
	CHANGELOGDESCRIPTION: "Version history and release notes",
	EXAMPLE: 'Example',
	EXAMPLE2: 'Example 2',
	EXAMPLE3: 'Example 3'
};

export default locale;
